import React from "react";
import { bootstrap } from "../delivery/bootstrap";
import { inMemoryStorageNotifications } from "../persistence/inMemoryStorageNotifications";
const notificationsRoot = ({ storage } = {
    storage: inMemoryStorageNotifications(),
}) => {
    const { Component } = bootstrap({ storage });
    return ({ children, includeReactQueryDevTools }) => (React.createElement(Component, { includeReactQueryDevTools: includeReactQueryDevTools }, children));
};
export { notificationsRoot };
